import type { Modifier, Obj } from '@popperjs/core';

export const sameWidthPopperModifier: Modifier<'sameWidth', Obj> = {
	name: 'sameWidth',
	enabled: true,
	phase: 'beforeWrite',
	requires: ['computeStyles'],
	fn: ({ state }) => {
		state.styles.popper!.minWidth = `${state.rects.reference.width}px`;
	},
	effect: ({ state }) => {
		state.elements.popper.style.minWidth = `${
			(state.elements.reference as HTMLElement).offsetWidth
		}px`;
	},
};

export const exactSameWidthPopperModifier: Modifier<'exactSameWidth', Obj> = {
	name: 'exactSameWidth',
	enabled: true,
	phase: 'beforeWrite',
	requires: ['computeStyles'],
	fn: ({ state }) => {
		state.styles.popper!.width = `${state.rects.reference.width}px`;
	},
	effect: ({ state }) => {
		state.elements.popper.style.width = `${
			(state.elements.reference as HTMLElement).offsetWidth
		}px`;
	},
};
